import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../notification/notification.service';
import { AlterarSenha } from './shared/alterarSenha';
import { NgForm } from '@angular/forms';
import { AlterarSenhaService } from './alterar-senha.service';

@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.css']
})
export class AlterarSenhaComponent implements OnInit {

  alterarSenha: AlterarSenha;
  senhaForm: NgForm;


  constructor(private notificationService: NotificationService, 
    private alterarSenhaService: AlterarSenhaService) {
    this.alterarSenha = new AlterarSenha();
  }

  ngOnInit() {
  }

  onSubmit() {
    this.alterarSenhaService.alterarSenha(this.alterarSenha)
    .subscribe(res => {
      console.log(res.json());
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/gerenciador/dashboard/alterar-senha/alterar-senha.component.ts